import Banner from "pages/banner";
import BannerUpdate from "pages/banner/update";
import Condidates from "pages/condidades";
import News from "pages/news";
import CreateNews from "pages/news/update";
import Testimonials from "pages/testimonials";
import Vacancy from "pages/vacancy";
import CreateVacancy from "pages/vacancy/update";
import { lazy } from "react";

const NotFound = lazy(() => import("pages/notFound"));
const Profile = lazy(() => import("pages/profile"));
const LocalizationPanel = lazy(() => import("pages/localizationPanel"));
const Category = lazy(() => import("pages/categories"));
const ProfileEdit = lazy(() => import("pages/profile/edit"));
const LogOut = lazy(() => import("pages/logOut"));
const Assets = lazy(() => import("pages/assets"));
const Brands = lazy(() => import("pages/brands"));
const Certificates = lazy(() => import("pages/certificates"));
const DefaultPage = lazy(() => import("pages/default"));
const Products = lazy(() => import("pages/products"));
const Create = lazy(() => import("pages/products/update"));
const Videos = lazy(() => import("pages/videos"));

export interface IRoute {
  path: string;
  key?: string | "*";
  element: JSX.Element;
  inner?: IRoute[];
  index?: boolean;
  title: string;
  access?: string[];
}

const privateRoutes: IRoute[] = [
  {
    path: "/",
    key: "default",
    title: "Bosh sahifa",
    element: <DefaultPage />,
    access: ["admin"],
  },
  {
    path: "/categories",
    key: "category",
    title: "Kategoriyalar",
    element: <Category />,
    access: ["admin"],
  },
  {
    path: "/partners",
    key: "partners",
    title: "Brandlar",
    element: <Brands />,
    access: ["admin"],
  },
  {
    path: "/products",
    key: "products",
    title: "Mahsulotlar",
    element: <Products />,
    access: ["admin"],
  },
  {
    path: "/products/create",
    key: "productsCreate",
    title: "Mahsulot qo'shish",
    element: <Create />,
    access: ["admin"],
  },
  {
    path: "/products/update/:id",
    key: "productsUpdate",
    title: "Mahsulotni yangilash",
    element: <Create />,
    access: ["admin"],
  },
  // {
  //   path: "/certificates",
  //   key: "certificates",
  //   title: "Sertifikatlar",
  //   element: <Certificates />,
  //   access: ["admin"],
  // },
  // {
  //   path: "/comments",
  //   key: "comments",
  //   title: "Izohlar",
  //   element: <Comments />,
  //   access: ["admin"],
  // },
  {
    path: "/videos",
    key: "video",
    title: "Videolar",
    element: <Videos />,
    access: ["admin"],
  },
  {
    path: "/testimonials",
    key: "testimonials",
    title: "Izohlar",
    element: <Testimonials />,
    access: ["admin"],
  },
  {
    path: "/news",
    key: "news",
    title: "Yangiliklar",
    element: <News />,
    access: ["admin"],
  },
    {
    path: "/news/create",
    key: "newsCreate",
    title: "Yangilik qo'shish",
    element: <CreateNews />,
    access: ["admin"],
  },
  {
    path: "/news/update/:id",
    key: "newsUpdate",
    title: "Yangilikni yangilash",
    element: <CreateNews />,
    access: ["admin"],
  },

  {
    path: "/banner",
    key: "banner",
    title: "Bannerlar",
    element: <Banner />,
    access: ["admin"],
  },
  {
    path: "/banner/update",
    key: "bannerUpdate",
    title: "Bannerlarni O'zgartirish",
    element: <BannerUpdate />,
    access: ["admin"],
  },
  {
    path: "/vacancy",
    key: "vacancy",
    title: "Vakansiyalar",
    element: <Vacancy />,
    access: ["admin"],
  },

  {
    path: "/vacancy/create",
    key: "vacancyCreate",
    title: "Vakansiya qo'shish",
    element: <CreateVacancy />,
    access: ["admin"],
  },
  {
    path: "/condidates",
    key: "condidates",
    title: "Kondidatlar",
    element: <Condidates />,
    access: ["admin"],
  },
  {
    path: "/vacancy/update/:id",
    key: "vacancyUpdate",
    title: "Vakansiyani yangilash",
    element: <CreateVacancy />,
    access: ["admin"],
  },

  {
    path: "/assets",
    key: "assets",
    title: "Sozlamalar",
    element: <Assets />,
    access: ["admin"],
  },
  {
    path: "/profile",
    key: "profile",
    title: "Profil",
    element: <Profile />,
    access: ["admin"],
  },
  {
    path: "/profile/edit",
    key: "profile-edit",
    title: "Profil / O'zgartirish",
    element: <ProfileEdit />,
    access: ["admin"],
  },
  {
    path: "/logout",
    key: "logout",
    title: "Profildan chiqish",
    element: <LogOut />,
    access: ["admin"],
  },
  {
    path: "*",
    key: "*",
    title: "",
    element: <NotFound />,
    access: ["admin"],
  },
  {
    path: "/localization",
    key: "localization",
    title: "Tarjimalar_paneli",
    element: <LocalizationPanel />,
    access: ["admin"],
  },
];

const publicRoutes: IRoute[] = [
  // {x
  //   path: "/login",
  //   element: <Login />,
  //   key: "inner-settings",
  //   title: "Welcome",
  // },
];

export { privateRoutes, publicRoutes };
